import userOrganizations from './userOrganizations';
export default userOrganizations;